module.exports = __webpack_public_path__ + "img/pad-in-bin.11b308b0.png";